import { createEvent } from "library/local-events/index.mjs"

export const AuthoringLegislation = createEvent("AuthoringLegislation")
export const AuthoringLegislationUpdated = AuthoringLegislation("updated")
export const AuthoringLegislationDeleted = AuthoringLegislation("deleted")

export const AuthoringLegislationGroup = createEvent("AuthoringLegislationGroup")
export const AuthoringLegislationGroupUpdated = AuthoringLegislationGroup("updated")
export const AuthoringLegislationGroupDeleted = AuthoringLegislationGroup("deleted")

// Payload carries the {legislationId, parentId} pair directly (no re-fetch needed — junction rows are immutable once written).
export const AuthoringLegislationGroupMembership = createEvent("AuthoringLegislationGroupMembership")
export const AuthoringLegislationGroupMembershipAdded = AuthoringLegislationGroupMembership("added")
export const AuthoringLegislationGroupMembershipRemoved = AuthoringLegislationGroupMembership("removed")
